import { useLazyQuery } from '@apollo/client';

import GetPaginatedFilteredPurchaseOrdersQuery from '@/graphql/contracts/getPaginatedFilteredPurchaseOrders.query.gql';
import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { GetPaginatedFilteredPurchaseOrders, GetPaginatedFilteredPurchaseOrdersVariables }
  from '@/graphql/contracts/_generated_/getPaginatedFilteredPurchaseOrders.query';
import { PurchaseOrderFilterInput } from '@/graphql/contracts/_generated_/contracts';
import { notificationService } from '@/services/notification/notification.client';
import { PaginatedFilteredGridData } from '@/utils/data-helpers/PaginatedFilteredGridData';

export type PaginatedFilteredPurchaseOrders = PaginatedFilteredGridData<PurchaseOrderFilterInput>;

export default function useGetPurchaseOrders() {
  const [_getPurchaseOrders, { loading }] = useLazyQuery<
  GetPaginatedFilteredPurchaseOrders,
  GetPaginatedFilteredPurchaseOrdersVariables
  >(GetPaginatedFilteredPurchaseOrdersQuery, {
    client: apolloClientContracts,
    fetchPolicy: 'no-cache',
    onError: (err) =>
      notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger',
      }),
  });

  const getPurchaseOrdersItems = async (params: PaginatedFilteredPurchaseOrders) => {
    const response = await _getPurchaseOrders({
      variables: {
        ...params,
      } as GetPaginatedFilteredPurchaseOrdersVariables,
    });
    return response.data?.purchaseOrders?.items ?? [];
  };

  const getPurchaseOrders = async (params: PaginatedFilteredPurchaseOrders) => {
    const response = await _getPurchaseOrders({
      variables: {
        ...params,
      } as GetPaginatedFilteredPurchaseOrdersVariables,
    });
    return response.data?.purchaseOrders;
  };

  return {
    getPurchaseOrders,
    getPurchaseOrdersItems,
    getPurchaseOrdersLoading: loading,
  };
}
